import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.updatePlansPricingDependingOnBillingCycle()
  }

  updatePlansPricingDependingOnBillingCycle() {
    if ($('input[name="billing_cycle"]:checked').val() == "monthly") {
      $(".monthly-price").show()
      $(".yearly-price").hide()
    } else {
      $(".monthly-price").hide()
      $(".yearly-price").show()
    }
  }

  updateBillingCycle(e) {
    $(e.currentTarget).find("input[type='radio']").prop("checked", true)
    $(e.currentTarget).parent().find(".fa-check-circle").removeClass("fa-check-circle").addClass("fa-circle")
    $(e.currentTarget).find(".fa-circle").removeClass("fa-circle").addClass("fa-check-circle")

    this.updatePlansPricingDependingOnBillingCycle()
  }

  moveToCheckout(e) {
    if (!$(e.currentTarget).hasClass("current")) {
      $(e.currentTarget).find("input[type='radio']").prop("checked", true)

      var level = $('input[name="level"]:checked').val()
      var billingCycle = $('input[name="billing_cycle"]:checked').val()

      Turbo.visit(`/subscriptions/checkout?level=${level}&billing_cycle=${billingCycle}`)
    }
  }
}
